import { api } from "../../../lib/axios";


export const getArchiveData = async (page = 1) => {
  const res = await api.get(`/api/requests/?paginate_by=8&page=${page}`);
  const data = res.data;

  if (data && Array.isArray(data.results)) {
    return {
      count: data.count,
      next: data.next,
      previous: data.previous,
      results: data.results,
    };
  }

  return {
    count: 0,
    results: [],
  };
};


export async function getRequestFromId({ id }) {
  const res = await api.get(`/api/requests/${id}/`);
  return res.data;
}


export const deleteRequest = async ({ id }) => {
  const res = await api.delete(`/api/requests/${id}/`);
  return res.data;
};

export const patchRequest = async ({ id, filename, prefix }) => {
  const res = await api.patch(`/api/edit_speech_filename/${id}/`, {
    filename: `${filename}.${prefix}`,
  });
  return res.data;
};

export const summarizeRequest = async ({ download_url}) => {
  const res = await api.post(`/api/summarize/`, {
    download_url,
    level: "level_1",
    type: "conversation",
  });
  return res.data;
};

export const searchRequest = async (query) => {
  const res = await api.post(`/api/search/`, { query });
  return res.data;
};
